import styled, { keyframes } from 'styled-components'

const loadingAnimation = keyframes`
  0%, 100% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
`

function LoadingDots() {
  return (
    <Wrapper>
      <Dot $delay="0s" color="#8BD2D7" />
      <Dot $delay="0.2s" color="#C6E6E8" />
      <Dot $delay="0.4s" color="#EEF8F8" />
    </Wrapper>
  )
}

export default LoadingDots

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Dot = styled.span<{ $delay: string; color: string }>`
  display: inline-block;

  width: 15px;
  height: 15px;
  margin: 0 5px;

  background-color: ${(props) => props.color};
  border-radius: 50%;

  animation: ${loadingAnimation} 1s linear infinite;
  animation-delay: ${(props) => props.$delay};
`
